function swalloader(){
    Swal.fire({
        title: 'Загружаем, ожидайте',
        allowOutsideClick:false,
        allowEscapeKey:false,
        heightAuto:false,
        footer: '<a id = "MailSupport" theme = "Ошибка в при загрузке" href = "javascript:void();">Написать в службу поддержки</a>',
        onBeforeOpen: () => {
            Swal.showLoading() 
        }
    });
}